import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getVendorVaultPath = () => urlHelper('/vendor-vault');
